enum DispatchSearchParam {
  STATUS = 'status',
}

export default DispatchSearchParam;
